import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SVGIcon } from "./Icons.component";

export const HoverWrapper = ({ child: Component, ...rest }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Component hovered={hovered} {...rest}></Component>
    </div>
  );
};

export const LinkButtonTab = ({ isfirst, svgColor, icon, title, ...rest }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Link
      {...rest}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <button
        type="button"
        className={`rounded-0 text-white ${hovered ? "fw-n" : "fw-l"}`}
        style={{
          width: "300px",
          minHeight: "50px",
          backgroundColor: hovered ? "#393b3c" : "#292b2c",
          transition: "0.1s ease-in-out",
          textAlign: "center",
          textDecoration: "none",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
          borderTop:
            isfirst || isfirst === "true"
              ? "1px solid rgba(255, 255, 255, 0.1)"
              : "0px",
        }}
      >
        <div className="d-flex flex-row justify-content-start align-items-center p-3">
          <span style={{ height: "30px", width: "30px" }}>
            <SVGIcon
              hovered={hovered}
              content={icon?.content}
              viewBox={icon?.viewBox}
              fillColor={svgColor}
            />
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span style={{ fontSize: "20px", color: "rgba(255, 255, 255, 0.3)" }}>
            {" "}
            |{" "}
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span className="font-montserrat" style={{ fontSize: "16px" }}>
            {title || "Button"}
          </span>
        </div>
      </button>
    </Link>
  );
};

export const SmallNavbarLink = ({ elem, color, hovered }) => {
  return (
    <Link to={elem.to} className="nav-link">
      <span
        style={{
          marginRight: "15px",
        }}
      >
        <SVGIcon
          content={elem.icon.content}
          viewBox={elem.icon.viewBox}
          hovered={hovered}
          fillColor={color}
        />
      </span>
      <span
        className="font-open-sans text-uppercase fw-b"
        style={{
          letterSpacing: "0.25ch",
        }}
      >
        {elem.title}
      </span>
    </Link>
  );
};
